module.exports = __webpack_public_path__ + "static/media/3DPPA43.fdc1953b.jpg";